import React, { FunctionComponent } from 'react'

import {
  StyledPatientInitialsAvatarCircle,
  PatientInitialsAvatarSize
} from './PatientInitialsAvatar.styles'
import { getPatientInitialsAvatarLabel } from '../patientInitialsDisplay'

export interface IPatientInitialsAvatarProps {
  initials?: string | null
  background?: string
  blur?: boolean
  size?: PatientInitialsAvatarSize
  className?: string
}

export const PatientInitialsAvatar: FunctionComponent<
  IPatientInitialsAvatarProps
> = ({ initials, background, blur, size = 'sm', className = 'avatar' }) => {
  const label = getPatientInitialsAvatarLabel(initials)

  return (
    <StyledPatientInitialsAvatarCircle
      className={className}
      background={background}
      blur={blur}
      size={size}
    >
      {label}
    </StyledPatientInitialsAvatarCircle>
  )
}
